import { Accordion, Box, Heading, Text } from "@chakra-ui/react";
import { DimensionGridAccordionItem } from "./index";
import * as React from "react";
import { useTranslation } from "react-i18next";

export const getFilledCategoriesArray = (data) => {
  return !data ? [] : Object.keys(data).filter(type => {
    return data[type].items?.length > 0 ?? false;
  });
};

function DimensionScopeSection({ title, data, hasOtherData }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  return (
    getFilledCategoriesArray(data).length === 0 && !hasOtherData ?
      null :
      <Box border="1px solid" borderColor="gray.200" borderRadius="md" padding={4} marginBottom={5}>
        <Heading size="md" marginBlock="1">
          {title}
        </Heading>
        {getFilledCategoriesArray(data).length > 0 ?
          <Accordion defaultIndex={[0]} allowMultiple margin="20px 0">
            {Object.keys(data).map(emissionsKey => {
              return data[emissionsKey].items.length > 0 ?
                <DimensionGridAccordionItem
                  key={`dimension-accordion-item-${emissionsKey}`}
                  data={data}
                  titleKey={`${emissionsKey}Title`}
                  type={emissionsKey}
                /> : null;
            })}
          </Accordion> :
          <Text fontSize="lg" fontWeight="bold">
            {t("scope1&2.dimension.noFilteredData")}
          </Text>
        }
      </Box>
  );
}

export default DimensionScopeSection;